export interface CountryOption {
  name: string;
  iso: string;
  dial: string;
  format: string;
  validLength: number[];
}

export const countries: CountryOption[] = [
  {
    name: 'Albania',
    iso: 'AL',
    dial: '+355',
    format: '0XX XXX XXXX',
    validLength: [9],
  },
  {
    name: 'Argentina',
    iso: 'AR',
    dial: '+54',
    format: '0XX XXXX XXXX',
    validLength: [10],
  },
  {
    name: 'Australia',
    iso: 'AU',
    dial: '+61',
    format: '0X XXXX XXXX',
    validLength: [9],
  },
  {
    name: 'Austria',
    iso: 'AT',
    dial: '+43',
    format: '0X XXX XX XX',
    validLength: [10],
  },
  {
    name: 'Belgium',
    iso: 'BE',
    dial: '+32',
    format: '0X XX XX XX XX',
    validLength: [9],
  },
  {
    name: 'Bosnia and Herzegovina',
    iso: 'BA',
    dial: '+387',
    format: '0XX XXX XXX',
    validLength: [8],
  },
  {
    name: 'Brazil',
    iso: 'BR',
    dial: '+55',
    format: '(XX) XXXXX-XXXX',
    validLength: [11],
  },
  {
    name: 'Bulgaria',
    iso: 'BG',
    dial: '+359',
    format: '0XX XXX XXXX',
    validLength: [10],
  },
  {
    name: 'Canada',
    iso: 'CA',
    dial: '+1',
    format: '(XXX) XXX-XXXX',
    validLength: [10],
  },
  {
    name: 'China',
    iso: 'CN',
    dial: '+86',
    format: '0XX XXXX XXXX',
    validLength: [11],
  },
  {
    name: 'Croatia',
    iso: 'HR',
    dial: '+385',
    format: '0XX XXX XXXX',
    validLength: [9],
  },
  {
    name: 'Cyprus',
    iso: 'CY',
    dial: '+357',
    format: '9X XXX XXX',
    validLength: [8],
  },
  {
    name: 'Czech Republic',
    iso: 'CZ',
    dial: '+420',
    format: '0XX XXX XXX',
    validLength: [9],
  },
  {
    name: 'Denmark',
    iso: 'DK',
    dial: '+45',
    format: 'XX XX XX XX',
    validLength: [8],
  },
  {
    name: 'Estonia',
    iso: 'EE',
    dial: '+372',
    format: '6XX XXX XXX',
    validLength: [7, 8],
  },
  {
    name: 'Finland',
    iso: 'FI',
    dial: '+358',
    format: '0XX XXX XXXX',
    validLength: [9, 10],
  },
  {
    name: 'France',
    iso: 'FR',
    dial: '+33',
    format: '0X XX XX XX XX',
    validLength: [9],
  },
  {
    name: 'Germany',
    iso: 'DE',
    dial: '+49',
    format: '0XXXX XXXXXX',
    validLength: [10, 11],
  },
  {
    name: 'Greece',
    iso: 'GR',
    dial: '+30',
    format: '0XX XXX XXXX',
    validLength: [10],
  },
  {
    name: 'Hungary',
    iso: 'HU',
    dial: '+36',
    format: '0XX XXX XXXX',
    validLength: [9],
  },
  {
    name: 'Iceland',
    iso: 'IS',
    dial: '+354',
    format: '0X XXX XXXX',
    validLength: [7],
  },
  {
    name: 'India',
    iso: 'IN',
    dial: '+91',
    format: 'XXXXX XXXXX',
    validLength: [10],
  },
  {
    name: 'Ireland',
    iso: 'IE',
    dial: '+353',
    format: '0X XXX XXXX',
    validLength: [9],
  },
  {
    name: 'Israel',
    iso: 'IL',
    dial: '+972',
    format: '0XX XXX XXXX',
    validLength: [9],
  },
  {
    name: 'Italy',
    iso: 'IT',
    dial: '+39',
    format: '0XX XXX XXXX',
    validLength: [9, 10],
  },
  {
    name: 'Japan',
    iso: 'JP',
    dial: '+81',
    format: '0X XXXX XXXX',
    validLength: [10, 11],
  },
  {
    name: 'Kosovo',
    iso: 'XK',
    dial: '+383',
    format: '0XX XXX XXX',
    validLength: [8],
  },
  {
    name: 'Latvia',
    iso: 'LV',
    dial: '+371',
    format: '2X XXX XXX',
    validLength: [8],
  },
  {
    name: 'Liechtenstein',
    iso: 'LI',
    dial: '+423',
    format: '0XX XXX XXX',
    validLength: [7],
  },
  {
    name: 'Lithuania',
    iso: 'LT',
    dial: '+370',
    format: '8XX XXX XXX',
    validLength: [8],
  },
  {
    name: 'Luxembourg',
    iso: 'LU',
    dial: '+352',
    format: '0XX XXX XXX',
    validLength: [9],
  },
  {
    name: 'Malta',
    iso: 'MT',
    dial: '+356',
    format: '2X XXX XXX',
    validLength: [8],
  },
  {
    name: 'Mexico',
    iso: 'MX',
    dial: '+52',
    format: '0XX XXXX XXXX',
    validLength: [10],
  },
  {
    name: 'Moldova',
    iso: 'MD',
    dial: '+373',
    format: '0XX XXX XXX',
    validLength: [8],
  },
  {
    name: 'Monaco',
    iso: 'MC',
    dial: '+377',
    format: '0X XX XX XX XX',
    validLength: [8, 9],
  },
  {
    name: 'Montenegro',
    iso: 'ME',
    dial: '+382',
    format: '0XX XXX XXX',
    validLength: [8],
  },
  {
    name: 'Netherlands',
    iso: 'NL',
    dial: '+31',
    format: '0XX XXX XXXX',
    validLength: [9],
  },
  {
    name: 'New Zealand',
    iso: 'NZ',
    dial: '+64',
    format: '0X XXX XXXX',
    validLength: [9],
  },
  {
    name: 'North Macedonia',
    iso: 'MK',
    dial: '+389',
    format: '0XX XXX XXX',
    validLength: [8],
  },
  {
    name: 'Norway',
    iso: 'NO',
    dial: '+47',
    format: 'XX XX XX XX',
    validLength: [8],
  },
  {
    name: 'Poland',
    iso: 'PL',
    dial: '+48',
    format: 'XX XXX XX XX',
    validLength: [9],
  },
  {
    name: 'Portugal',
    iso: 'PT',
    dial: '+351',
    format: '9XX XXX XXX',
    validLength: [9],
  },
  {
    name: 'Romania',
    iso: 'RO',
    dial: '+40',
    format: '0XX XXX XXXX',
    validLength: [10],
  },
  {
    name: 'Russia',
    iso: 'RU',
    dial: '+7',
    format: '0XX XXX XX XX',
    validLength: [10],
  },
  {
    name: 'San Marino',
    iso: 'SM',
    dial: '+378',
    format: '0XX XXX XXXX',
    validLength: [10],
  },
  {
    name: 'Serbia',
    iso: 'RS',
    dial: '+381',
    format: '0XX XXX XXXX',
    validLength: [9, 10],
  },
  {
    name: 'Singapore',
    iso: 'SG',
    dial: '+65',
    format: 'XXXX XXXX',
    validLength: [8],
  },
  {
    name: 'Slovakia',
    iso: 'SK',
    dial: '+421',
    format: '0XX XXX XXX',
    validLength: [9],
  },
  {
    name: 'Slovenia',
    iso: 'SI',
    dial: '+386',
    format: '0XX XXX XXX',
    validLength: [8],
  },
  {
    name: 'South Africa',
    iso: 'ZA',
    dial: '+27',
    format: '0XX XXX XXXX',
    validLength: [9],
  },
  {
    name: 'South Korea',
    iso: 'KR',
    dial: '+82',
    format: '0X XXXX XXXX',
    validLength: [10],
  },
  {
    name: 'Spain',
    iso: 'ES',
    dial: '+34',
    format: '6XX XXX XXX',
    validLength: [9],
  },
  {
    name: 'Sweden',
    iso: 'SE',
    dial: '+46',
    format: '0XX XXX XX XX',
    validLength: [9],
  },
  {
    name: 'Switzerland',
    iso: 'CH',
    dial: '+41',
    format: '0XX XXX XX XX',
    validLength: [9],
  },
  {
    name: 'Turkey',
    iso: 'TR',
    dial: '+90',
    format: '0XX XXX XXXX',
    validLength: [10],
  },
  {
    name: 'Ukraine',
    iso: 'UA',
    dial: '+380',
    format: '0XX XXX XXXX',
    validLength: [9],
  },
  {
    name: 'United Arab Emirates',
    iso: 'AE',
    dial: '+971',
    format: '0X XXX XXXX',
    validLength: [9],
  },
  {
    name: 'United Kingdom',
    iso: 'GB',
    dial: '+44',
    format: '0XXXX XXXXXX',
    validLength: [10],
  },
  {
    name: 'United States',
    iso: 'US',
    dial: '+1',
    format: '(XXX) XXX-XXXX',
    validLength: [10],
  },
  {
    name: 'Vatican City',
    iso: 'VA',
    dial: '+39',
    format: '06 698 XXXXX',
    validLength: [10],
  },
];
